import {ACTIONS} from "../01-actions/adminCategories"

const findDependencies = (list, rootId) => {
    let ids = [rootId];
    let result = [rootId];
    while (ids.length) {
        let id = ids.shift();
        for (let i = 0; i < list.length; i++) {
            if (list[i].parentId === id) {
                result.push(list[i]._id);
                ids.push(list[i]._id);
            }
        }
    }
    return result;
};

const initialState = {
    status: null,
    categories: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.CATEGORIES_LOADING:
            return {
                ...state,
                status: action.type,
            };
        case ACTIONS.CATEGORIES_LOADED:
            return {
                ...state,
                status: action.type,
                categories: action.data.categories,
                error: null,
            };
        case ACTIONS.CATEGORIES_LOAD_FAILED:
            return {
                ...state,
                status: action.type,
                categoriesLoadError: action.data.statusInfo
            };
        case ACTIONS.CATEGORY_ADDING:
            return {
                ...state,
                status: action.type,
                newCategory: action.data.newCategory
            };
        case ACTIONS.CATEGORY_ADDED:
            let newCategory = Object.assign({}, state.newCategory, {
                _id: action.data._id,
                order: action.data.order
            }, {subCategories: []});
            return {
                ...state,
                status: action.type,
                categories: [...state.categories, newCategory],
                error: null,
            };
        case ACTIONS.CATEGORY_ADD_FAILED:
            return {
                ...state,
                status: action.type,
                error: action.data.error
            };
        case ACTIONS.CATEGORY_REMOVING:
            return {
                ...state,
                status: action.type,
                removingCategoryId: action.data._id
            };
        case ACTIONS.CATEGORY_REMOVED:
            //-- remove the delete category
            //-- find the position for newCategory
            let dependencies = findDependencies(state.categories, state.removingCategoryId);
            let newCategories = state.categories.slice();
            for (let i = 0; i < dependencies.length; i++) {
                let index = newCategories.findIndex((c) => {
                    return (c._id === dependencies[i]);
                });
                if (index >= 0)
                    newCategories.splice(index, 1);
            }
            return {
                ...state,
                status: action.type,
                categories: newCategories,
                error: null,
            };
        case ACTIONS.CATEGORY_REMOVE_FAILED:
            return {
                ...state,
                status: action.type,
            };
        case ACTIONS.CATEGORY_UPDATING:
            return {
                ...state,
                status: action.type,
                updatingCategory: action.data
            };
        case ACTIONS.CATEGORY_UPDATED:
            //-- update new info
            let index = state.categories.findIndex((c) => (c._id === state.updatingCategory._id));
            return {
                ...state,
                status: action.type,
                categories: [...state.categories.slice(0, index), Object.assign({}, state.categories[index], {
                    parentId: state.updatingCategory.parentId,
                    name: state.updatingCategory.name
                }), ...state.categories.slice(index + 1)],
                error: null,
            };

        case ACTIONS.CATEGORY_UPDATE_FAILED:
            return {
                ...state,
                status: action.type,
                updatingCategory: action.data.statusInfo,
                error: action.data.error
            };

        case ACTIONS.CATEGORY_SWAPPED: {
            //-- update categories
            let category1Index = state.categories.findIndex(c => c._id === action.data.id1);
            let category2Index = state.categories.findIndex(c => c._id === action.data.id2);

            let order1 = state.categories[category1Index].order;
            let order2 = state.categories[category2Index].order;

            let newCategories = state.categories.slice();

            newCategories = [
                ...newCategories.slice(0, category1Index),
                {
                    ...newCategories[category1Index],
                    order: order2,
                },
                ...newCategories.slice(category1Index + 1)];

            newCategories = [
                ...newCategories.slice(0, category2Index),
                {
                    ...newCategories[category2Index],
                    order: order1,
                },
                ...newCategories.slice(category2Index + 1)];


            return {
                ...state,
                status: action.type,
                categories: newCategories,
            };
        }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/02-reducers/adminCategories.js